import React from 'react';
import { ModalBody } from './Body.styles';
import { IModalBody } from './interfaces';

interface IDialogModalBody extends IModalBody {
  message?: string;
  warning?: string;
  children?: React.ReactNode;
}

const DialogModalBody = ({
  message,
  warning,
  children,
  ...modalProps
}: IDialogModalBody) => {
  return (
    <ModalBody {...modalProps}>
      {message ? <p>{message}</p> : null}
      {warning ? <p>{warning}</p> : null}
      {children}
    </ModalBody>
  );
};

export default DialogModalBody;
